<template>
  <CardToolbox>
    <sdPageHeader title="SubStatuss">
      <template #subTitle>
        <span class="title-counter">{{ count }} substatus{{ count > 0 && count < 2 ? '' : 's' }}</span>
<!--        <sdAutoComplete :dataSource="searchData" width="100%" placeholder="Zoeken op naam" patterns/>-->
      </template>
      <template #buttons>
        <SubStatusAdd v-if="$can('create', 'substatus')"/>
      </template>
    </sdPageHeader>
  </CardToolbox>
  <Main>
    <a-row :gutter="15">
      <a-col :md="24">
        <SubStatusTable/>
      </a-col>
    </a-row>
  </Main>
</template>
<script>
import SubStatusTable from './component/SubStatusTable';
import {computed, ref, defineComponent, onMounted} from 'vue';
import {useStore} from 'vuex';
import {Main, CardToolbox} from '../styled';
import SubStatusAdd from "./SubStatusAdd";

const SubStatusList = defineComponent({
  name: 'SubStatusList',
  components: {SubStatusAdd, Main, CardToolbox, SubStatusTable},
  data() {
    return {
      showEditDrawer: false,
    }
  },
  setup() {
    const {state, dispatch} = useStore();
    const searchData = computed(() => state.headerSearchData);
    const count = computed(() => state.substatus.count);
    const selectedRowKeys = ref(0);
    const selectedRows = ref(0);

    onMounted(() => {
      dispatch('getParentStatusses')
      dispatch('getSubStatusses', {page: state.substatus.currentPage, pageSize: state.substatus.pageSize});
    });

    return {
      searchData,
      selectedRowKeys,
      selectedRows,
      count,
    };
  },
});

export default SubStatusList;
</script>
